/**
 * Global (not per-contractor) persistence of the last submitted
 * mandatory-form fields, so every contractor's get-in-touch form pre-fills
 * with what the homeowner already entered — same "one homeowner, one browser"
 * model as survey-storage.js.
 *
 * Data structure: { workTypes, fullName, contactNumber, flatNumber,
 * siteLocation, siteLocationDetails, updatedAt }
 */

const STORAGE_KEY = "fevicolInhomzLastEnquiry";

export function getLastEnquiry() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }
    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    if ("fullName" in parsed || "workTypes" in parsed) {
      return parsed;
    }
    // Legacy shape: { [dpId]: entry } — fall back to the most recent entry.
    const entries = Object.values(parsed).filter((entry) => entry && typeof entry === "object");
    return entries.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))[0] || null;
  } catch (error) {
    console.error("Error reading last enquiry details from localStorage:", error);
    return null;
  }
}

export function saveLastEnquiry(data) {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...data, updatedAt: Date.now() }));
    return true;
  } catch (error) {
    console.error("Error saving last enquiry details to localStorage:", error);
    return false;
  }
}
